module.exports = __webpack_public_path__ + "static/img/9.b693802.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/sp/9.png
// module id = y0+y
// module chunks = 0